import styled from 'styled-components';

import { Card } from '@xingternal/card';
import { mediaConfined } from '@xingternal/layout-tokens';
import { SkeletonBody, SkeletonButton, SkeletonHeadline, SkeletonProfileImage } from '@xingternal/skeleton';
import {
  scale090,
  scale200,
  scale210,
  scale260,
  scale310,
  scale380,
  spaceM,
  spaceS,
  spaceXL,
  spaceXXL,
} from '@xingternal/tokens';

export const Container = styled(Card)`
  padding-bottom: ${spaceXXL};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spaceM};
`;

export const Image = styled(SkeletonProfileImage)`
  margin-top: ${spaceXL};
  flex-shrink: 0;

  @media ${mediaConfined} {
    margin-top: 0;
  }
`;

export const Date = styled(SkeletonHeadline)`
  width: ${scale210};
  margin-bottom: ${spaceS};

  & > div {
    margin-bottom: ${spaceS};
    height: ${scale090};
  }
`;

export const Body = styled(SkeletonHeadline)`
  & > div {
    height: ${scale090};
    margin-bottom: ${spaceS};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ListItemContainer = styled.div`
  display: flex;
`;

export const ListItemText = styled.div`
  margin-left: ${spaceM};
  width: 100%;
`;

export const Title = styled(SkeletonHeadline)`
  width: ${scale380};
  margin-bottom: ${spaceS};
`;

export const Rating = styled(SkeletonBody)`
  width: ${scale310};
  margin-bottom: ${spaceS};
`;

export const Button = styled(SkeletonButton)`
  width: ${scale260};
  margin-left: ${scale200};
`;
